module.exports = __webpack_public_path__ + "img/13.f2bb27ab.png";